import { Flex } from '@mediahuis/chameleon-react';
import { Fragment } from 'react';
import { MultibrandIcon } from "../MultibrandIcon/index.js";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const iconsConfig = {
  ds: 'dsLogo',
  gva: 'gvaLogo',
  hbvl: 'hbvlLogo',
  nb: 'nbLogo',
  dg: 'dgLogo'
};
const brandLogoConfig = {
  sm: {
    height: '24px',
    width: '24px'
  },
  lg: {
    height: '30px',
    width: '30px'
  }
};
const plusLogoConfig = {
  sm: {
    height: '6px',
    width: '6px'
  },
  lg: {
    height: '6px',
    width: '6px'
  }
};
const MultibrandLogos = _ref => {
  let {
    brands,
    size = 'lg'
  } = _ref;
  return /*#__PURE__*/_jsx(Flex, {
    alignItems: "center",
    style: {
      gap: size === 'sm' ? '2px' : '4.5px'
    },
    children: brands.map((brand, brandIndex) => {
      if (brandIndex === brands.length - 1) {
        return /*#__PURE__*/_jsx(MultibrandIcon, {
          icon: iconsConfig[brand],
          height: brandLogoConfig[size].height,
          width: brandLogoConfig[size].width
        }, brand);
      }
      return /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx(MultibrandIcon, {
          icon: iconsConfig[brand],
          height: brandLogoConfig[size].height,
          width: brandLogoConfig[size].width
        }, brand), /*#__PURE__*/_jsx(MultibrandIcon, {
          icon: "plus",
          height: plusLogoConfig[size].height,
          width: plusLogoConfig[size].width
        }, brand)]
      }, brand);
    })
  });
};
export default MultibrandLogos;